import React, { useEffect, useState } from 'react';
import { Button } from './Button';
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  const scrollTo = (id: string) => (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${scrolled ? 'bg-background/95 backdrop-blur-sm border-border' : 'bg-transparent border-transparent'}`} data-id="element-33">
      <div className="container flex items-center justify-between h-16 md:h-18" data-id="element-34">
        <a href="/" className="flex items-center gap-1 font-mono text-sm font-medium tracking-tight text-foreground" data-id="element-35">
          <img src="https://cdn.magicpatterns.com/uploads/99D4e53cgjQaS46pLTjE3K/image.png" alt="reddog.studio logo" className="h-6 w-6 object-contain shrink-0 -mr-0.5" data-id="element-36" />
          reddog<span className="text-muted-foreground" data-id="element-37">.studio</span>
        </a>
        <nav className="hidden md:flex items-center gap-8" aria-label="Primary" data-id="element-38">
          <a href="#how-we-engage" onClick={scrollTo('how-we-engage')} className="font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors" data-id="element-39">
            How we engage
          </a>
          <a href="#why-we-exist" onClick={scrollTo('why-we-exist')} className="font-mono text-xs uppercase tracking-widest text-muted-foreground hover:text-foreground transition-colors" data-id="element-40">
            Why we exist
          </a>
        </nav>
        <Button size="sm" onClick={scrollTo('start-engagement')} className="rounded-none font-mono text-xs uppercase tracking-widest" data-id="element-41">
          Book a call
        </Button>
      </div>
    </header>;
}